import { Paper, Stack, Typography } from '@mui/material';
import type { HomePageInvoiceSummaryComparisons, HomePageRevenueByBillingStatus } from '@weft/api-definition';
import { DEFAULT_CURRENCY } from '@weft/types';
import { HomePageInvoiceStatusChartSection } from './HomePageInvoiceStatusChartSection';
import { HomePageInvoiceStatusStatBox } from './HomePageInvoiceStatusStatBox';

type HomePageInvoiceStatusSectionProps = {
  invoiceStatusData: HomePageRevenueByBillingStatus;
  comparisonsData: HomePageInvoiceSummaryComparisons
};

export const HomePageInvoiceStatusSection: React.FC<HomePageInvoiceStatusSectionProps> = ({ invoiceStatusData, comparisonsData }) => {
  return (
    <Paper
      variant='outlined' 
      sx={(theme) => ({
        boxShadow: theme.shadows[1],
        padding: 3,
      })}
    >
      <Typography variant='h6'>Invoice Status Summary</Typography>
      <Stack
        direction="row"
        gap={2}
        paddingTop={2}
      >

        <HomePageInvoiceStatusChartSection 
          currency={DEFAULT_CURRENCY}
          lastMonthAmount={comparisonsData.lastMonthInvoicesSum}
          totalAmount={comparisonsData.totalInvoicesSum}
          openPrice={invoiceStatusData.None ?? 0}
          overduePrice={invoiceStatusData.Overdue ?? 0}
          paidPrice={invoiceStatusData.Paid ?? 0}
          pendingPrice={invoiceStatusData.PendingPayment ?? 0}
        />

        <Stack
          gap={2}
          flexGrow={1}
          minHeight="100%"
        >
          <HomePageInvoiceStatusStatBox 
            label='Active Customers'
            value={comparisonsData.totalActiveCustomers}
            previousMonthValue={comparisonsData.lastMonthActiveCustomers}
          />
          <HomePageInvoiceStatusStatBox 
            label='Active Contracts'
            value={comparisonsData.totalActiveContracts}
            previousMonthValue={comparisonsData.lastMonthActiveContracts}
          />
        </Stack>
      </Stack>
    </Paper>
  );
};